import React, { useCallback, useEffect, useState, useMemo } from "react";
import "./See-All.css";
import { useNavigate, useParams } from "react-router-dom";
import default_post from "../../Assets/images/default-post.jpeg"
import NotFoundPost from "../../Assets/NoPostFound";
import Loading from "../../Assets/Loading";
import {IoFilter, IoLocationOutline } from "react-icons/io5";

function SeeAllPosts() {
  const [cars, setCars] = useState([]);
  const [location, setLocation] = useState(""); 
  const [category, setCategory] = useState(""); 
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    priceFilter: "default",
    priceRange: { from: "", to: "" },
  });
  const [tempFilters, setTempFilters] = useState({
    priceFilter: "default",
    priceRange: { from: "", to: "" },
  });
  const [showFilters, setShowFilters] = useState(false);
  const carsPerPage = 50;

  const { locationParam, categoryParam  } = useParams();
  const navigate = useNavigate();

  const getCars = useCallback(async () => {
    try {
      const response = await fetch(`https://in.quiko.in/api/sell/allposts`, {
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        setCars(data.response_data);
      }
    } catch (error) {
      console.log("service page error ", error);
    }
  }, []);

// Free Classified ads in Ahmdedabad post ads post ads Classified in Ahmedabad - Quiko
useEffect(() => {
  getCars();
  setCurrentPage(1); // Reset to the first page whenever filters change
  window.scrollTo(0, 0);// Scroll to the top of the page when the component mounts
  document.title = ` Free Classified ads in ${locationParam || "All Locations"} ${categoryParam ? categoryParam + " category" : ""} | Advertise old product in ${locationParam}  - Quiko `;

  //========= description ===============
  const descriptionContent = `Free Classified Ads in ${locationParam} Buy, Sell and Rent  Old Products, Furniture, Properies, bikes, cars, Used Mobile/Phones | Find HOstels, Jobs, Self-Drive, Cars, in ${locationParam}   | All posts in ${locationParam || "All Locations"} ${categoryParam ? `for ${categoryParam}` : ""} - Find great deals on Quiko!`;
  let descriptionMetaTag = document.querySelector('meta[name="description"]');
  
  if (descriptionMetaTag) {
    // Update existing meta tag
    descriptionMetaTag.content = descriptionContent;
  } else {
    // Create a new meta tag if it doesn't exist
    descriptionMetaTag = document.createElement('meta');
    descriptionMetaTag.name = "description";
    descriptionMetaTag.content = descriptionContent;
    document.head.appendChild(descriptionMetaTag);
  }

    // Update or create meta keywords
    const keywordsContent = `Quiko.in -Post Free Classified Ads in ${locationParam} Without Registration, Free ad posting ${locationParam}, post free ads ${locationParam} , Post ${locationParam} ads, Free classified ads ${locationParam}, post free ads ${locationParam}, ${locationParam} classifieds , indian ads, Post Free Classified Ads in ${locationParam} Without Registration, Free ad posting ${locationParam}, post free ads ${locationParam} , Post ${locationParam} ads, Free classified ads ${locationParam} , ${locationParam} classifieds, ${locationParam} classified ads, indian classified ads , india classifieds free, free post india classifieds, Bharatclassifieds , Bharath classifieds ads, Bharatads, Bharat classifieds, Free Advertising Post , indian job classifieds, free classified sites in india , post free ads in india , classified submission sites in india , classified submission sites 2024, classified ads sites for india , classified websites india , free classifieds ads , classified sites in india , classifieds submission sites 2024, Free classified submission sites 2024 , Free india classified submission sites 2024 , high da classified submission sites , 1000 free ad posting websites , free classified ads posting , free classified ads online , local free classified ads , free online advertising sites , free ads classified , free ads online , where to post ads , post ads online free , Free classified ads ${locationParam} list , Post free classified ads ${locationParam} , ${locationParam} free classified ads sites , Free classified ads portals in ${locationParam} , Best free classified in ${locationParam} , Free classified sites for ${locationParam} , Free classified sites in ${locationParam} with high pr , Free classified in ${locationParam} , Free classifieds in ${locationParam} list , Free classified ads in ${locationParam} post ads online , post free classified in ${locationParam} , Free classified job sites in ${locationParam} , Free classifieds ${locationParam} list , Free classified listing sites ${locationParam} , Free classifieds olx ${locationParam} , Free classifieds online ${locationParam} , Free classified sites in ${locationParam} for ad posting , Free classified posting sites in ${locationParam} , Free classified sites ${locationParam} , Free ${locationParam}n classified sites ${locationParam} , Free classifieds posting sites ${locationParam} , Free classified websites ${locationParam} , Free classified ads websites in ${locationParam} , Free classified submission sites list in ${locationParam} 2023, Free ad posting ${locationParam} websites , Free classified ads backlink Generation , Best Free Offpage SEO , Free SEO Booster, Free classified Ad Publisher , Free ${locationParam}n classified websites list , Free ${locationParam}n classified websites list download , Free ${locationParam}n classified , Free ${locationParam}n classified websites list for ad posting , Free ${locationParam}n classified list , Free ${locationParam}n classified ads , Free ${locationParam} classified website , Free classified ads sites ${locationParam} , Free classified sites in ${locationParam} 2023 , free classified india , india free classified USA , indian classified website , ${locationParam} classifieds usa , desi classifieds usa , india abroad classifieds , post free classified ads india , click india post free ads ' free advertisement posting sites india , free ad posting classified websites , post free ads online india , free classifieds ads in india , free ad post website india , classified ads free posting sites , click india post free ads , free ad posting sites india , post free ads in india , free ads posting ind , classified ads post free , free online advertising in india , classifieds free ads posting , free site for posting ads , top free ad posting sites, free classified ads portal , free website for classified ads , post free classified business , free ads posting sites india , click in free post ad , post free classifieds ads , Free classifieds in india post free ads mumbai , Free classifieds in india post free ads delhi , Free classifieds in india post free ads mumbai furniture , Free classifieds in india post free ads mumbai electronics , Free classifieds in india post free ads mumbai contact number , Free classifieds in india post free ads mumbai cars free classifieds post free ad , free ads posting sites , free classified ads in india , free classifieds url , Free classifieds url ${locationParam} , Best free classifieds url , free classified ads posting sites , free classified ads sites worldwide , top 100 free classified websites in india , free classified sites in india , post free classified ads , best classified sites , 1000 free classified ads sites in india , top 10 classified sites in india , free classified sites , Top 100 free classified websites in india 2023 , top 100 classified sites , free classified submission sites , free classified submission sites in india 2023 , post free ads india , Post free ads india delhi , free classifieds ads , classifieds ads , uk classifieds ads , free classifieds ads posting , free classifieds ads without registration list , free classifieds ads portal , free classifieds ads sites list without registration , free classifieds ads in chennai , free classifieds ads online free classifieds ads posting websites list chennai free classifieds ads , classifieds ads in usa , free classifieds ads in usa , free classifieds ads worldwide , free classifieds ads posting in india without registration , international classifieds ads free , bangalore classifieds ads , free classifieds ads in india without registration , free classifieds ads posting in india list , free classifieds ads sites list in india , free classifieds ads sites list in india without registration , free classifieds ads list in india , free classifieds ads without registration in india , classifieds ads sites , dubai classifieds ads , uae classifieds ads post sites , classifieds ads in india , classifieds ads india , free classifieds ads india , free classifieds ads usa , usa classifieds ads , classifieds ads uae , free classifieds ads sites , times of india classifieds ads , hyderabad free classifieds ads , free classifieds ads sites list in tamilnadu , singapore classifieds ads , classifieds ads posting , what are classifieds ads , personal classifieds ads , classifieds ads in uae , classifieds ads software , free classifieds ads chennai , classifieds ads usa , coimbatore free classifieds ads , australia classifieds ads , classifieds ads script free download , malaysia classifieds ads post sites , dc classifieds ads , free classifieds ads in canada , premium classifieds ads , classifieds ads free , classifieds ads ranchi , google classifieds ads , personals classifieds ads , classifieds ads zimbabwe , free classifieds ads posting in bangalore , free classifieds ads portals , free classifieds ads site , buy and sell classifieds ads , post free classifieds ads without registration india , local classifieds ads , free local classifieds ads , classifieds ads in dubai , free local online india classifieds ads , free classifieds ads mumbai , uk free classifieds ads , classifieds ads sites list usa , free classifieds ads without registration , classifieds ads list , classifieds ads uk , classifieds ads for free , times of india classifieds ads booking , chennai classifieds ads , free classifieds ads sehore , classifieds ads submission , classifieds ads online , free classifieds ads in dubai , free pet classifieds ads , classifieds ads website template , uae classifieds ads , free classifieds ads in coimbatore , classifieds ads wordpress theme , classifieds ads website , classifieds ads site , ksl classifieds ads , bmfa classifieds ads , kolkata classifieds ads,Ahmedabad classifieds ads, indian classifieds ads , top free classifieds ads , london classifieds ads , locanto free classifieds ads , kuwait classifieds ads , free classifieds ads posting sites in india , free classifieds ads posting in chennai , free advertising post , free advertising posting sites , free classified ads posting sites , free classified ads posting sites in india , free classified ads posting sites in usa , free advertising poster templates , post free classifieds ads sites , free advertising poster , free advertisement poster maker ,`;
    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    
    if (keywordsMetaTag) {
      // Update existing meta tag
      keywordsMetaTag.content = keywordsContent;
    } else {
      // Create a new meta tag if it doesn't exist
      keywordsMetaTag = document.createElement('meta');
      keywordsMetaTag.name = "keywords";
      keywordsMetaTag.content = keywordsContent;
      document.head.appendChild(keywordsMetaTag);
    }
  

}, [getCars, locationParam, categoryParam]);

useEffect(() => {
  if (locationParam) setLocation(locationParam);
  if (categoryParam) setCategory(categoryParam);
}, [locationParam, categoryParam]);

// Update URL when location changes
const handleLocationChange = (e) => {
  const selectedLocation = e.target.value;
  setLocation(selectedLocation);

  if (selectedLocation) {
    if (category && category !== "all") {
      navigate(`/p/${selectedLocation}/${category}`);
    } else {
      navigate(`/p/${selectedLocation}`);
    }
  } else {
    navigate("/p");
  }
};

// Update URL when category changes
const handleCategoryChange = (e) => {
  const selectedCategory = e.target.value;
  setCategory(selectedCategory);

  if (selectedCategory && selectedCategory !== "all") {
    navigate(`/p/${location}/${selectedCategory}`);
  } else {
    navigate(`/p/${location}`);
  }
};

// Helper function to update URL with location and category
// const updateURL = (location, category) => {
//   const path = `/p/${location || "all"}/${category || "all"}`;
//   navigate(path);
// };

  // Filter cars based on selected location and category
  const filteredCars = useMemo(() => {
    return cars.filter((curEle) => {
      const lowerLocation = location.toLowerCase();
      const lowerCategory = category.toLowerCase();

      return (
        ((curEle.state && curEle.state.toLowerCase().includes(lowerLocation)) ||
          (curEle.aria && curEle.aria.toLowerCase().includes(lowerLocation))) &&

            (curEle.category && curEle.category.toLowerCase().includes(lowerCategory))
      );
    }).sort((a, b) => {
      // Sort by premium status first, then by creation date
      if (a.isPremium && !b.isPremium) return -1;
      if (!a.isPremium && b.isPremium) return 1;
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  }, [cars, location, category])
  .filter((car) => {
    if (appliedFilters.priceRange.from || appliedFilters.priceRange.to) {
      const from = parseInt(appliedFilters.priceRange.from || 0, 10);
      const to = parseInt(
        appliedFilters.priceRange.to || Number.MAX_VALUE,
        10
      );
      return car.price >= from && car.price <= to;
    }
    return true;
  })
  .sort((a, b) => {
    if (appliedFilters.priceFilter === "low-to-high") return a.price - b.price;
    if (appliedFilters.priceFilter === "high-to-low") return b.price - a.price;
    return 0;
  });

  if (cars.length === 0) {
    return <Loading />;
  }
  if (filteredCars.length === 0) {
    return <NotFoundPost/>;
  }

  const indexOfLastCar = currentPage * carsPerPage;
  const indexOfFirstCar = indexOfLastCar - carsPerPage;
  const currentCars = filteredCars.slice(indexOfFirstCar, indexOfLastCar);

  const totalPages = Math.ceil(filteredCars.length / carsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getPaginationNumbers = () => {
    const pageNumbers = [];
    if (totalPages > 1) {
      if (currentPage === 1) {
        pageNumbers.push(1, 2, '...');
      } else if (currentPage === 2) {
        pageNumbers.push(1, 2, 3);
      } else if (currentPage >= 3) {
        pageNumbers.push(currentPage - 1, currentPage, '...');
      }
    } else if (totalPages === 1) {
      pageNumbers.push(1);
    }
    return pageNumbers;
  };

  const timeAgo = (dateString) => {
    const now = new Date();
    const postDate = new Date(dateString);
    const diffInSeconds = Math.floor((now - postDate) / 1000);
    const seconds = diffInSeconds % 60;
    const minutes = Math.floor(diffInSeconds / 60) % 60;
    const hours = Math.floor(diffInSeconds / 3600) % 24;
    const days = Math.floor(diffInSeconds / 86400);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);

    if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
    if (weeks > 0) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  };

  const isLatest = (createdAt) => {
    const now = new Date();
    const postDate = new Date(createdAt);
    const differenceInHours = (now - postDate) / (1000 * 60 * 60);
    return differenceInHours <= 24;
  };

  const handleCardClick = (_id, category) => {
    navigate(`/${category}/${_id}`);
  };

  const applyFilters = () => {
    setAppliedFilters(tempFilters);
    setShowFilters(false);
  };
  return (
    <div className="all-cars-container" style={{ marginTop: "20px" }}>
      <h1 className="homecard-title bikes user-profile-title" id="homecard-text" style={{ width: "100%" , maxWidth:"100%", }}>
        All Posts in {location}
      </h1>

            {/* Price Filter Controls */}
            <div className="price-filter-container">
        <div
          className="price-filter-icon"
          onClick={() => setShowFilters(!showFilters)}
        >
          <IoFilter />
        </div>

        {/* Filter Box */}
        {showFilters && (
          <div className="price-filter-box">
            <select
              value={tempFilters.priceFilter}
              onChange={(e) =>
                setTempFilters({ ...tempFilters, priceFilter: e.target.value })
              }
            >
              <option value="default">Sort by Price</option>
              <option value="low-to-high">Low to High</option>
              <option value="high-to-low">High to Low</option>
            </select>
            <div className="price-price-range">
              <input
                type="number"
                placeholder="From"
                value={tempFilters.priceRange.from}
                onChange={(e) =>
                  setTempFilters({
                    ...tempFilters,
                    priceRange: {
                      ...tempFilters.priceRange,
                      from: e.target.value,
                    },
                  })
                }
              />
              <input
                type="number"
                placeholder="To"
                value={tempFilters.priceRange.to}
                onChange={(e) =>
                  setTempFilters({
                    ...tempFilters,
                    priceRange: {
                      ...tempFilters.priceRange,
                      to: e.target.value,
                    },
                  })
                }
              />
            </div>
            <button onClick={applyFilters}>Apply</button>
          </div>
        )}
      </div>
      
      <div className="filter-container">
        {/* Location Dropdown */}
        <div className="filter-wrapper">
          <label htmlFor="location">Select Location:</label>
          <select
            id="location"
            value={location}
            onChange={handleLocationChange}
            className="custom-select"
          >
            <option value="">All Locations</option>
            <option value="Ahmedabad">Ahmedabad</option>
            <option value="Delhi">Delhi</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Kolkata">Kolkata</option>
            <option value="Chennai">Chennai</option>
            <option value="Pune">Pune</option>
            <option value="Hyderabad">Hyderabad</option>
            <option value="Jaipur">Jaipur</option>
            <option value="Gurgaon">Gurgaon</option>
          </select>
        </div>

        {/* Category Dropdown */}
        <div className="filter-wrapper">
          <label htmlFor="category">Select Category:</label>
          <select
            id="category"
            value={category}
            onChange={handleCategoryChange}
            className="custom-select"
          >
            <option value="">All Categories</option>
            <option value="car">Cars</option>
            <option value="bikes">Bikes</option>
            <option value="mobiles">Mobiles</option>
            <option value="electronics">Electronics</option>
            <option value="jobs">Jobs</option>
            <option value="furnitures">Furnitures</option>
            <option value="hostels">Hostel & PGs</option>
            <option value="selfdrives">Self-Drives</option>
            <option value="cloths">Cloths</option>
            <option value="renthouse">Rent House</option>
            <option value="salehouse">Sale House</option>
            <option value="rentshop">Rent Shop</option>
            <option value="saleshop">Sale Shop</option>
            <option value="plots">Plots</option>
            <option value="others">Others</option>
          </select>
        </div>
      </div>

      <div className="all-cars" style={{ marginTop: "20px", marginLeft:"-20px" }}>
        {currentCars.map((curEle, index) => {
          const { _id, title, imageUrl, price, aria, createdAt, category, rent, isPremium, salaryfrom } = curEle;
          return (
            <div className="sell-all-post-child" key={index}>
              <div className="child post-container" onClick={() => handleCardClick(_id, category)}  style={ isPremium ? { border:'5px solid yellow'} : {border : 'none'} }  >
                {isLatest(createdAt) && <span className="latest-label">Latest</span>}
                {isPremium && <span className="premium-badge">FEATURED</span>}
                <img src={`https://in.quiko.in/${imageUrl[0]}`} alt="Car"  onError={(e) => (e.target.src = default_post)}/>
                <h4 className="card-price-title">Rs {price || rent || salaryfrom}</h4>
                <h6>{timeAgo(createdAt)}</h6>
                <h5>{title.length > 50 ? `${title.slice(0, 50)}...` : title}</h5>
                <h6><IoLocationOutline /> {aria.length > 40 ? `${aria.slice(0, 40)}...` : aria}
                </h6>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div className="pagination" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        {currentPage > 1 && (
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
        )}
        {getPaginationNumbers().map((page, i) => (
          <button
            key={i}
            onClick={() => typeof page === 'number' && paginate(page)}
            className={currentPage === page ? "active" : ""}
            disabled={page === '...'}
          >
            {page}
          </button>
        ))}
        {currentPage < totalPages && (
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
            Next
          </button>
        )}
      </div>
    </div>
  );
}

export default SeeAllPosts;
